import { CommandPaletteResult, CommandPaletteResultGroup } from "../types";
import { PatientResultItem } from "@/features/patient";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface CommandPaletteGroupProps {
  group: CommandPaletteResultGroup["group"];
  items: CommandPaletteResult[];
  flatResults: CommandPaletteResult[];
  onSelect: (result: CommandPaletteResult) => void;
  children?: ReactNode;
}

export function CommandPaletteGroup({
  group,
  items,
  flatResults,
  onSelect,
  children,
}: CommandPaletteGroupProps) {
  return (
    <div>
      <div className="px-5 pt-2.5 pb-1.5">
        <span className="text-action-disabled-content text-[10px] font-bold tracking-[0.06em] uppercase">
          {group}
        </span>
      </div>
      {children}
      {items.map((item) => {
        if (item.kind === "patient" && item.patient) {
          return (
            <PatientResultItem
              key={item.id}
              patient={item.patient}
              cardInfo={item.patient.card ?? null}
              onSelect={() => onSelect(item)}
              flatResults={flatResults}
            />
          );
        }

        const Icon = item.icon;
        return (
          <button
            key={item.id}
            onClick={() => onSelect(item)}
            className={twMerge(
              "flex w-full cursor-pointer items-center gap-3 border-0 px-5 py-2 text-left transition-colors duration-100",
            )}
          >
            {Icon && (
              <div className="bg-brand-gray flex size-8 shrink-0 items-center justify-center rounded-lg">
                <Icon
                  className="text-action-disabled-content size-4"
                  strokeWidth={1.8}
                />
              </div>
            )}
            <div className="flex min-w-0 flex-1 flex-col gap-px">
              <span className="overflow-hidden text-[13px] font-semibold text-ellipsis whitespace-nowrap">
                {item.label}
              </span>
              {item.sublabel && (
                <span className="text-action-disabled-content overflow-hidden text-[11px] tracking-[0.02em] text-ellipsis whitespace-nowrap">
                  {item.sublabel}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
